import Vue from 'vue'
import axios from 'axios';
import api from './../api';
import config from '@config';
const nodeEnv = process.env.NODE_ENV;
var baseUrl = config[nodeEnv].apiHost;  

const state = {
  login_email: '',
  login_token: '',
  login_name: '',
  state_id: '',
  account_id: '',
  selected_path: '/home',
  isCommunity: false,
  temp_email: '',
  temp_token: '',
  temp_name: '',
  organization: {},
  manager: {}
}

const getters = {
  // Filtering currentUser
  currentUser: state => {
    return {
      email: state.login_email,
      token: state.login_token,
      name: state.login_name,
      state_id: state.state_id,
      account_id: state.account_id
    }
  }
}

const mutations = {
  updateData (state, payload) {
    switch (payload.name) {
      case 'email':
        state.temp_email = payload.value
        break
      case 'token':
        state.temp_token = payload.value
        break
      case 'name':
        state.temp_name = payload.name
        break
      default:
        console.log('Error:Dont directly mutate Vuex store')
    }
  },
  getOrganization (state, data) {
    state.organization = data
  },
  getManager (state, data) {
    state.manager = data
  },
  getLocalUser (state) {
    state.login_email = sessionStorage.getItem('email')
    state.login_token = sessionStorage.getItem('token')
    state.login_name = sessionStorage.getItem('name')
    state.state_id = sessionStorage.getItem('state_id')
    state.account_id = sessionStorage.getItem('account_id')
    state.manager = JSON.parse(sessionStorage.getItem('manager'))
    state.organization = JSON.parse(sessionStorage.getItem('organization'))


  },
  getStateId (state) {
    state.state_id = sessionStorage.getItem('state_id')
  },

  setSelectedPath (state, payload) {
    if ('/community' == payload) {
      state.isCommunity = true;
      console.log('/community true=', state.isCommunity)
    } else {
      state.selected_path = payload;
      state.isCommunity = false;
    }

  },
  setUser (state, payload) {
    if (payload.email) {
      state.login_email = payload.email
    }
    if (payload.state_id) {
      state.state_id = payload.state_id
    }
    if (payload.token) {
      state.login_token = payload.token
    }
    if (payload.name) {
      state.login_name = payload.name
    }
    if (payload.account_id) {
      state.account_id = payload.account_id
    }


  },
  logout (state) {
    sessionStorage.removeItem('email')
    sessionStorage.removeItem('token')
    sessionStorage.removeItem('name')
    sessionStorage.removeItem('state_id')
    sessionStorage.removeItem('account_id')
    sessionStorage.removeItem('organization')
    sessionStorage.removeItem('manager')
    state.login_email = ''
    state.state_id = ''
    state.login_token = ''
    state.login_name = ''
    state.account_id = ''
    state.organization = {}
    state.manager = {}
  }
}

const actions = {
  /**
   * Login 邮箱密码登录
   * new Promise((resolve, reject) => {})
   * email: payload.email
   * pass: payload.pass
   * name: payload.name
   */
  login ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(baseUrl+'/auth/login', params).then((res) => {
        if (res.status == 200) {
          if (res.data.code == 0) {
            sessionStorage.setItem('email', res.data.data.email)
            sessionStorage.setItem('state_id', res.data.data.state_id)
            sessionStorage.setItem('name', res.data.data.organization.name)
            sessionStorage.setItem('organization', JSON.stringify(res.data.data.organization))
            sessionStorage.setItem('manager', JSON.stringify(res.data.data.manager))
            commit({
              type: 'setUser',
              email: res.data.data.email,
              state_id: res.data.data.state_id,
              name: res.data.data.organization.name

            })
            commit(
              'getOrganization',
              res.data.data.organization
            )
            commit(
              'getManager',
              res.data.data.manager
            )
          }
          resolve(res.data)
        }
        else {
          reject(res)
        }
      })

    })
  },

  //发送给组织管理员手机验证码
  sendLoginPhoneCode ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(baseUrl+'/auth/sendLoginPhoneCode', { params: params }).then((res) => {
        if (res.status == 200) {
          resolve(res.data)
        }
        else {
          reject(res)
        }
      })

    })
  },

  //验证管理员收到的验证码
  loginVerify ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(baseUrl+'/auth/confirmLoginPhoneCode', params).then((res) => {
        if (res.status == 200) {
          if (res.data.code == 0) {
            sessionStorage.setItem('token', res.data.data.token)
            sessionStorage.setItem('account_id', res.data.data.account_id)
            commit({
              type: 'setUser',
              token: res.data.data.token,
              account_id: res.data.data.account_id
            })
          }
          resolve(res.data)
        }
        else {
          reject(res)
        }
      })

    })
  },




  /**
    * Register 发送注册邮箱验证码
    * new Promise((resolve, reject) => {})
    * email: params.email
    * g_recaptcha_token: params.g_recaptcha_token
    */
  checkEmailUnique ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(baseUrl+'/auth/checkEmailUnique', {
        params: params
      }).then((res) => {
        if (res.status == 200) {
          resolve(res.data)
        }
        else {
          reject(res)
        }
      })

    })
  },


  /**
   * Register 发送注册邮箱验证码
   * new Promise((resolve, reject) => {})
   * email: params.email
   * g_recaptcha_token: params.g_recaptcha_token
   */
  sendRegisterEmailCode ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(baseUrl+'/auth/sendEmailCode', {
        params: params
      }).then((res) => {
        if (res.status == 200) {
          resolve(res.data)
        }
        else {
          reject(res)
        }
      })

    })
  },

  //验证邮箱验证码并注册账号
  registerIcgUser ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(baseUrl+'/auth/registerIcgUser', params).then((res) => {
        if (res.status == 200) {
          if (res.data.code == 0) {
            sessionStorage.setItem('state_id', res.data.data.state_id)
            commit({
              type: 'setUser',
              state_id: res.data.data.state_id
            })
          }
          resolve(res.data)
        }
        else {
          reject(res)
        }
      })

    })
  },

  //注册完成前，新增管理员时发送短信验证码
  sendRegisterMobileCode ({ commit }, params) {
    return new Promise((resolve, reject) => {
      let postURL;
      if (params.editType == 1) {
        postURL = baseUrl+'/auth/sendPhoneCode'
      } else if (params.editType == 2) {
        postURL =baseUrl+ '/user/sendModifyPhoneCode'
      } else {
        reject()
      }
      axios.post(postURL, params).then((res) => {
        if (res.status == 200) {
          resolve(res.data)
        }
        else {
          reject(res)
        }
      })

    })
  },


  /**
 * 根据state_id获取Token
 * new Promise((resolve, reject) => {})
 * state_id: params.state_id
 *
 */
  getTokenByStateId ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(baseUrl+'/auth/getTokenByStateId', { params: params }).then((res) => {
        if (res.status == 200) {
          if (res.data.code == 0) {
            sessionStorage.setItem('token', res.data.data.token)
            sessionStorage.setItem('email', res.data.data.email)
            sessionStorage.setItem('name', res.data.data.organization.name)
            sessionStorage.setItem('account_id', res.data.data.account_id)

            sessionStorage.setItem('organization', JSON.stringify(res.data.data.organization))
            sessionStorage.setItem('manager', JSON.stringify(res.data.data.manager))
            commit({
              type: 'setUser',
              token: res.data.data.token,
              email: res.data.data.email,
              account_id: res.data.data.account_id,
              name: res.data.data.organization.name,
            })
            commit(
              'getOrganization',
              res.data.data.organization
            )
            commit(
              'getManager',
              res.data.data.manager
            )
          }
          resolve(res.data)
        }
        else {
          reject(res)
        }
      })

    })
  },
  //修改用户注册信息
  editRegisterUser ({ commit }, params) {
    return new Promise((resolve, reject) => {
      let requestConfig = {
        headers: {
          'Authorization': 'Bearer ' + state.login_token
        },
      }
      Vue.prototype.instance.post('/user/updateUserInfo', params, requestConfig).then((res) => {
        if (res.status == 200) {
          if (res.data.code == 0) {
            sessionStorage.setItem('organization', JSON.stringify(res.data.data.organization))
            sessionStorage.setItem('manager', JSON.stringify(res.data.data.manager))
            commit({
              type: 'setUser',
              name: res.data.data.organization.name,
            })
            commit(
              'getOrganization',
              res.data.data.organization
            )
            commit(
              'getManager',
              res.data.data.manager
            )
          }
          resolve(res.data)
        }
        else {
          reject(res)
        }
      })

    })
  },

  //完善用户注册信息
  updateRegisterUser ({ commit }, params) {
    return new Promise((resolve, reject) => {
      Vue.prototype.instance.post('/auth/updateRegisterUser', params).then((res) => {
        if (res.status == 200) {
          if (res.data.code == 0) {
            sessionStorage.setItem('token', res.data.data.token)
            sessionStorage.setItem('email', res.data.data.email)
            sessionStorage.setItem('name', res.data.data.organization.name)
            sessionStorage.setItem('account_id', res.data.data.account_id)

            sessionStorage.setItem('organization', JSON.stringify(res.data.data.organization))
            sessionStorage.setItem('manager', JSON.stringify(res.data.data.manager))
            commit({
              type: 'setUser',
              token: res.data.data.token,
              email: res.data.data.email,
              account_id: res.data.data.account_id,
              name: res.data.data.organization.name,
            })
            commit(
              'getOrganization',
              res.data.data.organization
            )
            commit(
              'getManager',
              res.data.data.manager
            )
          }
          resolve(res.data)
        }
        else {
          reject(res)
        }
      })

    })
  },

  //修改密码
  alterPassword ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(baseUrl+'/user/updateUserPassword', params).then((res) => {
        if (res.status == 200) {
          resolve(res.data)
        }
        else {
          reject(res)
        }
      })

    })
  },
  /**
  * 重置密码发送邮箱验证码
  * new Promise((resolve, reject) => {})
  * email: params.email
  * g_recaptcha_token: params.g_recaptcha_token
  */
  sendRetrieveEmailCode ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(baseUrl+'/auth/sendRetrieveEmailCode', {
        params: params
      }).then((res) => {
        if (res.status == 200) {
          resolve(res.data)
        }
        else {
          reject(res)
        }
      })

    })
  },
  /**
    * 验证邮箱收到的重置密码验证码是否正确
    * new Promise((resolve, reject) => {})
    * email: params.email
    * g_recaptcha_token: params.g_recaptcha_token
    */
  checkRetrieveEmailCode ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(baseUrl+'/auth/checkRetrieveEmailCode', params).then((res) => {
        if (res.status == 200) {
          resolve(res.data)
        }
        else {
          reject(res)
        }
      })

    })
  },
  /**
   * 重置修改密码
   * new Promise((resolve, reject) => {})
   * email: params.email
   * g_recaptcha_token: params.g_recaptcha_token
   */
  retrievePassword ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(baseUrl+'/auth/retrievePassword', params).then((res) => {
        if (res.status == 200) {
          resolve(res.data)
        }
        else {
          reject(res)
        }
      })

    })
  },


  /**
  * 申请专业应用开发者
  * new Promise((resolve, reject) => {})
  */
  applyDeveloper ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(baseUrl+'/user/applyDeveloper', params).then((res) => {
        if (res.status == 200) {
          resolve(res.data)
        }
        else {
          reject(res)
        }
      })

    })
  },




  end ({ commit }, params) {
    return new Promise((resolve, reject) => {


    })
  }

}






export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js